var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4532 24.8928C31.1754 27.5027 29.6967 29.9484 27.2497 31.3612C23.1842 33.7084 17.9857 32.3155 15.6385 28.25L15.3885 27.817M14.5462 23.1071C14.824 20.4972 16.3028 18.0515 18.7497 16.6387C22.8152 14.2915 28.0138 15.6845 30.361 19.75L30.611 20.183M14.4932 30.0659L15.2252 27.3339L17.9573 28.0659M28.0422 19.934L30.7743 20.666L31.5063 17.934M22.9997 19.5V24L25.4997 25.5",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtj);
export default __webpack_public_path__ + "static/media/ptj.e089e09a101695dfba0848f293f68810.svg";
export { ForwardRef as ReactComponent };